import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import { BusinessClient, BusinessDto, StoreAddressDto, StoreWithAddressDto } from 'src/app/api/portal-api.generated';
import { StoreDto } from 'src/app/api/portal-api.generated';
import {PaymentsClient} from '../../../../api/wallet-api.generated';
import {catchError, map} from 'rxjs/operators';
import {ToastrMessageServiceService} from '../../../../shared/services/toastr-message/toastr-message-service.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessSettingsService {
  private hideTabs = false;
  constructor(private businessClient: BusinessClient,
              private paymentsClient: PaymentsClient,
              private toastrMessageServiceService: ToastrMessageServiceService) { }

  get hideTabsValue() {
    return this.hideTabs;
  }

  set hideTabsValue(newState: boolean) {
    this.hideTabs = newState;
  }

  getBusinessDetails(profileId: string): Observable<BusinessDto> {
    if (!profileId) {
      return;
    }

    return this.businessClient.getBusiness(profileId);
  }

  updateBusinessDetails(newBusinessDto: BusinessDto) {
    if (!newBusinessDto) {
      return;
    }

    return this.businessClient.updateBusiness(newBusinessDto);
  }

  getStores(profileId: string): Observable<StoreWithAddressDto[]> {
    if (!profileId) {
      return;
    }

    return this.businessClient.getStores(profileId);
  }

  updateStoreDetails(newStoreDto: StoreDto) {
    if (!newStoreDto) {
      return;
    }

    return this.businessClient.updateStore(newStoreDto);
  }

  createStore(newStoreDto: StoreDto) {
    if (!newStoreDto) {
      return;
    }

    return this.businessClient.createStore(newStoreDto);
  }

  publishStore(profileId: string, storeId: string) {
    if (!profileId) {
      return;
    }
    return this.businessClient.publishStore(profileId, storeId);
  }

  unpublishStore(profileId: string, storeId: string) {
    if (!profileId) {
      return;
    }
    return this.businessClient.unpublishStore(profileId, storeId);
  }

  deleteStore(profileId: string, storeId: string) {
    if (!profileId) {
      return;
    }
    return this.businessClient.deleteStore(profileId, storeId);
  }

  updateStoreAddress(addressDto: StoreAddressDto) {
    if (!addressDto) {
      return;
    }
    return this.businessClient.updateStoreAddress(addressDto);
  }

  getSegments(id: string) {
    return this.paymentsClient.getSegmentsV2(id).pipe(
      map((data) => data || []),
      catchError((e) => {
        this.toastrMessageServiceService.error('onboarding.myworld.dealer-connect.errors.my-world-error');
        return throwError(e);
      })
    );
  }
}
